import {defineMessages} from 'react-intl';

export default defineMessages({
	nothing: {
		id: 'dropdownMenu.nothing',
		defaultMessage: 'Nothing found',
	},
	search: {
		id: 'dropdownMenu.search',
		defaultMessage: 'Type in to search',
	},
	closeButton: {
		id: 'flyout.shareProduct.form.closeButton',
		defaultMessage: 'Close'
	},
});
